import { environmentBase } from './environment.base';

export const environment = {
  ...environmentBase,
  // Demo / prize (optional): set `registerInterestUrl` (e.g. Google Form) and/or `contactEmail` on
  // `environmentBase` or override here after the spread.
  production: false,
  name: 'development',
  firebase: {
    apiKey: 'AIzaSyBGMHqqf44lpVtgJxyOqvl3lmI0PGirelw',
    authDomain: 'crowdctrl.app',
    projectId: 'jubilant-octo-parakeet-dev',
    storageBucket: 'jubilant-octo-parakeet-dev.firebasestorage.app',
    messagingSenderId: '376131366176',
    appId: '1:376131366176:web:1b8ea6e2d34af6ca56fb45',
    measurementId: 'G-F4RN72RCSE',
  },
  apiUrl: 'https://australia-southeast2-jubilant-octo-parakeet-dev.cloudfunctions.net',
  appCheckToken: '', // Will be set at runtime
  unsplashAccessKey: 'avG3Jyqy-O23zE80a3hMgTW-uZr8kCWfyaZepZvbsaY',
};
